
// src/connects/pickup-diaries-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { getArray } from '../helpers/store'
import find from 'lodash/find'

export const mapStateToProps = (state, ownProps) => {
  const group_id = ownProps.params && ownProps.params.group_id || ownProps.params && ownProps.params.group_id
  const group = ownProps.group || getArray('group_id', state.groups.items, group_id)

  return {
    group_id, group,
    diary_ids: ownProps.params && ownProps.params.diary_ids ||
                ownProps.location && ownProps.location.query && ownProps.location.query.diary_ids,
    reported_at: ownProps.params && ownProps.params.reported_at ||
                ownProps.location && ownProps.location.query && ownProps.location.query.reported_at,
    diaries: state.subDiaries.items || ownProps.params && ownProps.params.diaries,
    user: state.user.current,
    _hasMore: state.subDiaries.hasMore,
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return {
    hasMore: stateProps.diary_ids ? false : stateProps._hasMore,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchDiaries: (props)=> {
      if (props.group_id && props.diary_ids)
        dispatch(actions.fetchSubDiaries(props.group_id, 0, { 'diary_ids[]': props.diary_ids }))
      else if (props.group_id && !props.diary_ids)
        dispatch(actions.fetchSubDiaries(
          props.group_id, props.diaries && props.diaries.length || 0, {
            reported_at_only: props.reported_at,
            category: props.params && props.params.category,
            user_id: props.params && props.params.user_id,
          }
        ))
      else
        dispatch(actions.fetchHomeSubDiaries(0, { 'diary_ids[]': props.diary_ids }))
    },

    readDiary: (props, diary)=> {
      const read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
      !read && dispatch(actions.markDiaryRead(diary.diary_id))
    },
  
    willMount: (props)=> {
      props.fetchDiaries(props)
    },
  
    willUpdate: (props, nextProps) => {
      if (props.group_id != nextProps.group_id ||
          props.reported_at != nextProps.reported_at ||
          props.params && nextProps.params && props.params.category != nextProps.params.category ||
          props.params && nextProps.params && props.params.user_id != nextProps.params.user_id)
        dispatch(actions.clearSubDiaries())

      if (props.diary_ids != nextProps.diary_ids && nextProps.diary_ids)
        nextProps.fetchDiaries(nextProps)
    },

    willUnmount: () => dispatch(actions.clearSubDiaries()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/pickup-diaries-page.js